/**
 * @title costcopay-fobs.js: Sub module for Account pages
 * @description: This module is used to query and handle costco pay receipts
 */
define(['ajaxmodular'], function(ajaxModular) {
	let CostcoPayTransactionHistory = {
		GET_COSTCO_PAY_TRANS_HIST : '/AjaxCostcoPayGetTransactionCmd',
		getForm: function(){
			return $('#tran-history-filter');
		},
		init: function() {
			$('#purchase-history-tab').on('shown.bs.tab', function(event){
				CostcoPayTransactionHistory.getCostcoPayReceipts();
			});
		},
		/**
		 * Function used to query the costco pay transaction history to get a list of
		 * transaction history by calling the ajax command with the form content. 
		 * 
		 * This function will be called upon when there is a need to replace the entire content
		 * of the transaction history. Namely when filter or the sort method change.
		 */
		getCostcoPayReceipts: function() {
			let form = CostcoPayTransactionHistory.getForm();
			
			let errorCont = $('#tran-history-crit-error');
			errorCont.empty();
			
			let selectedPeriod = $('#trans_hist_date_select option:selected').data("value");
			let fromMonth = parseInt(selectedPeriod.fromMonth);
			let fromYear =  parseInt(selectedPeriod.fromYear);
			let endMonth = parseInt(selectedPeriod.endMonth);
			let endYear = parseInt(selectedPeriod.endYear);
			
			$(form).find('input[name=fromMonth]').val(fromMonth);
	        $(form).find('input[name=fromYear]').val(fromYear);
	        $(form).find('input[name=endMonth]').val(endMonth);
	        $(form).find('input[name=endYear]').val(endYear);
			
			//Set offset back to 0 since we want go back to 0
			$(form).find('input[name=offset]').val(0);
			
			$('#costco-pay-transactions').addClass('ajax-busy');
			ajaxModular.ajax_update_state({
				url: CostcoPayTransactionHistory.GET_COSTCO_PAY_TRANS_HIST,
				method: 'GET',
				data: COSTCO.util.objectifyArray(form.serializeArray()),
				dataType:'json',
				done: function(data, textStatus, jqXHR, options) {
					if(!data.errorMessage) {
						ajaxModular.ajax_update_default_done(data, textStatus, jqXHR, options);
					}
					else {
						let errorCont = $('#tran-history-crit-error');
						errorCont.text(data.errorMessage);
						errorCont.removeClass('hide');
					}
				},
				always: function() {
					$('#costco-pay-transactions').removeClass('ajax-busy');
				}
			});
		},
		/**
		 * Function used to export costco pay transaction history in a csv
		 */
		exportCostcoPayReceipts: function(e) {
			let form = CostcoPayTransactionHistory.getForm();
			let param = COSTCO.util.objectifyArray(form.serializeArray());
			let downloadUrl = COSTCO.util.makeUrl('/ExportCostcoPayTransactionCmd',param);
			
			window.open(downloadUrl);
			
			e.preventDefault();
		},
		/**
		 * Function used to get the next set of record for costco pay transaction history
		 * 
		 */
		getMoreCostoPayReceipts: function(e) {
			
			let form = CostcoPayTransactionHistory.getForm();
			
			let numRecords = $('.transaction-row').length;
			$(form).find('input[name=offset]').val(numRecords);
			
			$('#costco-pay-transactions').addClass('ajax-busy');
			
			ajaxModular.ajax_update_state({
				url: CostcoPayTransactionHistory.GET_COSTCO_PAY_TRANS_HIST,
				method: 'GET',
				data: COSTCO.util.objectifyArray(form.serializeArray()),
				dataType:'json',
				done: function(data, textStatus, jqXHR, options) {
					//get rid of the current load more link
					$('#pagination-footer').remove();
					ajaxModular.ajax_update_default_done(data, textStatus, jqXHR, 
							{ajax_replace_content:COSTCO.AjaxModular.ajax_append_content});
				},
				always: function() {
					$('#costco-pay-transactions').removeClass('ajax-busy');
				}
			});
			//Used to prevent link to go up
			e.preventDefault();
		}
	}
	window.COSTCO.CostcoPayTransactionHistory = CostcoPayTransactionHistory;
	return CostcoPayTransactionHistory;
});


// WEBPACK FOOTER //
// ./js/account/costcopay-transaction-history.js